/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../graphql.generated'

import { EnrollmentFragmentDoc } from '../participant/patientQueries.generated'

const defaultOptions = {} as const
export type GetDevPanelPatientQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetDevPanelPatientQuery = {
  __typename?: 'Query'
  patients: Array<{
    __typename?: 'Patient'
    uid: string
    email?: string | null
    language?: string | null
    details?: Types.JSONObject | null
    timezone?: string | null
    enrollment: {
      __typename?: 'Enrollment'
      id: string
      state: Types.EnrollmentState
      programID: string
      programStartDate?: Date | null
      lastStateTransitionAt: Date
      createdAt: Date
      enrolledFromPreviousAdvancedProgram: boolean
    }
  }>
}

export type FindDevPanelPatientByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input']
}>

export type FindDevPanelPatientByEmailQuery = {
  __typename?: 'Query'
  searchPatientsV2: {
    __typename?: 'SearchPatientsResponse'
    patients: Array<{ __typename?: 'Patient'; uid: string; email?: string | null }>
  }
}

export const GetDevPanelPatientDocument = gql`
  query getDevPanelPatient($uid: ID!) {
    patients(uids: [$uid]) {
      uid
      email
      language
      details
      timezone
      enrollment {
        ...Enrollment
      }
    }
  }
  ${EnrollmentFragmentDoc}
`

/**
 * __useGetDevPanelPatientQuery__
 *
 * To run a query within a React component, call `useGetDevPanelPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevPanelPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevPanelPatientQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetDevPanelPatientQuery(
  baseOptions: Apollo.QueryHookOptions<GetDevPanelPatientQuery, GetDevPanelPatientQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDevPanelPatientQuery, GetDevPanelPatientQueryVariables>(GetDevPanelPatientDocument, options)
}
export function useGetDevPanelPatientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDevPanelPatientQuery, GetDevPanelPatientQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDevPanelPatientQuery, GetDevPanelPatientQueryVariables>(
    GetDevPanelPatientDocument,
    options
  )
}
export type GetDevPanelPatientQueryHookResult = ReturnType<typeof useGetDevPanelPatientQuery>
export type GetDevPanelPatientLazyQueryHookResult = ReturnType<typeof useGetDevPanelPatientLazyQuery>
export type GetDevPanelPatientQueryResult = Apollo.QueryResult<
  GetDevPanelPatientQuery,
  GetDevPanelPatientQueryVariables
>
export const FindDevPanelPatientByEmailDocument = gql`
  query findDevPanelPatientByEmail($email: String!) {
    searchPatientsV2(query: $email, includeOnlyPrimaryPatients: false) {
      patients {
        uid
        email
      }
    }
  }
`

/**
 * __useFindDevPanelPatientByEmailQuery__
 *
 * To run a query within a React component, call `useFindDevPanelPatientByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDevPanelPatientByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDevPanelPatientByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFindDevPanelPatientByEmailQuery(
  baseOptions: Apollo.QueryHookOptions<FindDevPanelPatientByEmailQuery, FindDevPanelPatientByEmailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FindDevPanelPatientByEmailQuery, FindDevPanelPatientByEmailQueryVariables>(
    FindDevPanelPatientByEmailDocument,
    options
  )
}
export function useFindDevPanelPatientByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FindDevPanelPatientByEmailQuery, FindDevPanelPatientByEmailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FindDevPanelPatientByEmailQuery, FindDevPanelPatientByEmailQueryVariables>(
    FindDevPanelPatientByEmailDocument,
    options
  )
}
export type FindDevPanelPatientByEmailQueryHookResult = ReturnType<typeof useFindDevPanelPatientByEmailQuery>
export type FindDevPanelPatientByEmailLazyQueryHookResult = ReturnType<typeof useFindDevPanelPatientByEmailLazyQuery>
export type FindDevPanelPatientByEmailQueryResult = Apollo.QueryResult<
  FindDevPanelPatientByEmailQuery,
  FindDevPanelPatientByEmailQueryVariables
>
